import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Container = styled.div`
  width: 100%;
  margin-top: 90px;
  padding: 32px 35px 122px;
`

export const Title = styled.h2`
  font-family: ${theme.font.inter};
  font-weight: ${theme.font.semiBold};
  font-size: ${theme.font.sizes.large};
  line-height: ${theme.font.sizes.xlarge};
  color: ${theme.colors.brown};
`

export const Card = styled.div`
  padding: 25px;
  margin-bottom: 15px;

  background: ${theme.colors.mainBg};
  box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);
  border-radius: ${theme.border.normal};
`

export const CardkHeader = styled.div`
`

export const FeedbackList = styled.div`
  margin-top: 22px;
  min-height: 30vh;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 26px;
`

export const StarFeedbackList = styled.div`
  margin-top: 22px;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 26px;
`
